import type { Field } from './models.ts';
import type { FieldSeason } from '../property/models.ts';
import type { FieldWithCropzone } from './field-cropzone.models.ts';

export interface AdaptedFieldsAndSeasons {
  fields: Field[];
  fieldSeasons: FieldSeason[];
}

export function adaptFieldsWithCropzones(items: FieldWithCropzone[]): AdaptedFieldsAndSeasons {
  const fields: Field[] = [];
  const fieldSeasons: FieldSeason[] = [];

  items.forEach(item => {
    fields.push({
      id: item.id,
      name: item.name,
      property_id: item.property_id,
      parent_region_id: item.parent_region_id,
      geometry: (item.geometry ?? { type: 'Polygon', coordinates: [] }) as Field['geometry'],
      declared_area: item.declared_area,
      calculated_area: item.calculated_area,
      tags: item.tags,
      updated_at: item.updated_at,
      deleted_at: null,
      json_extended_attributes: item.json_extended_attributes ?? {},
      valid_since: item.valid_since,
      valid_until: item.valid_until,
      archived: item.archived
    });

    if (item.cropzone) {
      fieldSeasons.push({
        id: item.cropzone.id,
        areaId: item.cropzone.field_id,
        seasonId: item.cropzone.season_id,
        varieties: item.cropzone.varieties,
        startsAt: item.cropzone.starts_at,
        endsAt: item.cropzone.ends_at
      });
    }
  });

  return { fields, fieldSeasons };
}
